module.exports = __webpack_public_path__ + "static/media/rt-bus-route-4.7d08e9d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/rt-bus-route-4.svg
// module id = 250
// module chunks = 0